import React from 'react'

import { useSettings } from '../../hooks/useSettings'

const FailedSVG = () => {
  const { isDarkMode } = useSettings()
  const color = isDarkMode ? '#0E2E4C' : '#fff'
  const secColor = isDarkMode ? '#fff' : '#0E2E4C'

  return (
    <svg
      className="self-center"
      width="40"
      height="40"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      fill={secColor}
    >
      <g strokeWidth="0" />
      <g strokeLinecap="round" strokeLinejoin="round" />
      <g fillRule="evenodd">
        <path d="M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7" />
        <path d="M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0" fill={color} />
        <path d="M7 5.969 5.599 4.568a.29.29 0 0 0-.413.004l-.614.614a.294.294 0 0 0-.004.413L5.968 7l-1.4 1.401a.29.29 0 0 0 .004.413l.614.614c.113.114.3.117.413.004L7 8.032l1.401 1.4a.29.29 0 0 0 .413-.004l.614-.614a.294.294 0 0 0 .004-.413L8.032 7l1.4-1.401a.29.29 0 0 0-.004-.413l-.614-.614a.294.294 0 0 0-.413-.004L7 5.968z" />
      </g>
    </svg>
  )
}

export default FailedSVG
